import React, { Fragment } from "react";
import GuidedTour from "../../../components/GuidedTour/GuidedTour";

const Footer = () => {
  return (
    <Fragment>
      <GuidedTour />
    </Fragment>
  );
};

export default Footer;
